import Auth from 'live/services/authorization'

export const Permission = {
    get isAdmin () {
        return Auth.Permission.ADMIN || Auth.Permission.SUPER_USER
    },

    get viewAdmin () {
        return Live.Permission.VIEW_ADMIN_AREA
    },

    get canCreateActivityLog () {
        return this.isAdmin || Live.Permission.CREATE_ACTIVITY_LOG
    }
}
